/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Announcements_TitleInputs */

const fr_announcements_title = /** @type {(inputs: Announcements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualités`)
};

const en_announcements_title = /** @type {(inputs: Announcements_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`News`)
};

/**
* | output |
* | --- |
* | "News" |
*
* @param {Announcements_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const announcements_title = /** @type {((inputs?: Announcements_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Announcements_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_announcements_title(inputs)
	return en_announcements_title(inputs)
});